import styled from 'styled-components'
import { colors, fonts } from 'modules/dashboard/Home/Dashboard.global.styles'
import { fontSize } from '../../DashboardSettings/DashboardSettings.styles'
import Formsy from 'formsy-react'
import FormInput from 'components/UI/FormInput/FormInput'
import Button from 'components/UI/Button/Button'

export const StyledForm = styled(Formsy)`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: -15px;

  & .InputWrapper:nth-child(2){
    width: 80%;
    margin: auto;
  }
`

export const StyledFormInput = styled(FormInput)`
  font-size: ${fontSize.small};
  margin: auto;

  &:last-child{
    margin-bottom: 10px;
  }

  &.StudentNumber > div:first-child{
    width: 100%;
  }

  &.StudentNumber > div:first-child > div {
    width: 100%;
    white-space: nowrap;
    padding-right: 20px;
    margin-left: 0;
  }
`

export const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 35px;
`
